import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from '../modules/axios.js'
import router from '../routes'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import {Notification} from "element-ui";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        applications: [],
        showIdentifyDeviceMessage: false,
        permissionEditorMatrixViewIsActive: false,
    },
    mutations: {
        setUser(state, user) {
            state.user = user
        },
        setApplications(state, apps) {
            state.applications = apps
        },
        setIdentifyDeviceMessageState(state, value) {
            state.showIdentifyDeviceMessage = value;
        },
        logout(state){
            state.user = null
        },
        setMatrixViewState(state, status) {
            state.permissionEditorMatrixViewIsActive = status;
        },
    },
    getters: {
        getUser: state => state.user,
        getIdentifyDeviceMessageState: state => state.showIdentifyDeviceMessage,
        matrixViewIsActive: state => state.permissionEditorMatrixViewIsActive,
    },
    actions: {
        async login({commit}, user){
            await axios.post('/api/login', user)
                .then(res => {
                    commit('setUser', res.data);
                    //router.push(router.history.current.query.redirect || '/')
                    location.href = '/';
                })
                .catch(({response}) => {
                    if (response.status === 422) {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data.message,
                            type: 'error',
                            confirmButtonText: 'OK'
                        })
                    } else if (response.status === 403) {
                        Notification({
                            iconClass: 'fas fa-exclamation-triangle text-danger',
                            title: response.data.message,
                            position: 'bottom-right'
                        })
                    } else if (response.status === 406) {
                        commit('setIdentifyDeviceMessageState', true);
                    }
                    console.warn(response.data);
                    console.log(response);
                })
        },
        async refreshUser({commit}){
            await axios.get('/api/profile').then(response => {
                commit('setUser', response.data.data);
            }).catch(({response}) => {
                this.$notify({
                    title: response.data.message,
                    type: 'danger',
                });
            });
        },
        async logout({commit, state}){
            await axios.delete('/api/logout')
                .then(() => {
                })
                .catch(({response}) => {
                    this.$notify({
                        title: response.data.message,
                        type: 'danger',
                    });
                })
                .then(() => {
                    Cookies.remove('access_token');
                    commit('logout');
                    window.location.reload(true);
                })
        },
        async authorizeDevice({commit}, token){
            await axios.post('/api/authorizeDevice', {token})
                .then(res => {
                    commit('setUser', res.data);
                    location.href = '/'
                    //router.push(router.history.current.query.redirect || '/dashboard')
                })
                .catch(({response}) => {
                    this.$notify({
                        title: response.data.message,
                        type: 'danger',
                    });
                })
        }
    },
    plugins: [createPersistedState({
        paths: [
            'user',
            'permissionEditorMatrixViewIsActive',
        ]
    })]
})
